<template>
    <button class="button-cart">
        <add-to-cart-base :id="id">
            <template slot-scope="{ addItem }">
                <a
                    href="#"
                    class="button-cart text-white flex"
                    :class="mobile ? 'mobile' : ''"
                    @click.prevent.stop="addItemToCart(addItem)"
                    :title="__('Kosárba')"
                    :disabled="disabled"
                >
                    <span>{{ __('Kosárba') }}</span>
                    <svg class="icon" aria-label="Kosár">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-cart"></use>
                    </svg>
                </a>
            </template>
        </add-to-cart-base>
    </button>
</template>

<script>
export default {
    name: 'AddToCart',
    props: {
        id: {
            type: Object,
            required: true
        },
        mobile: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        addItemToCart(addItem) {
            if (this.disabled) {
                this.$bus.$emit('required-size-modal')
                return
            }

            this.$loading.show()

            addItem()
        }
    }
}
</script>

<style lang="scss" scoped>
.btn.btn-primary.mobile {
    padding: 4px 8px;
    font-size: 12px;
    margin-right: 0.5rem;
}
</style>
